<template lang="html">
  <div class="wrapper">
    <load-spinner v-if="showSpinner"></load-spinner>
    <b-modal ref="req-result">
      <p class="my-4"
         v-bind:class="{ 'message-success' : this.reqSuccess, 'message-fail': !this.reqSuccess } ">{{
          reqResult
        }}</p>
    </b-modal>

    <div class="clients" v-if="!reload">
      <b-pagination
          align="center"
          v-model="currentPage"
          :total-rows="length"
          :per-page="perPage"
          aria-controls="my-table"
          @change="click"
      ></b-pagination>
      <b-table
          id="my-table"
          :items="this.items"
          :fields="this.fields"
          striped responsive="sm"
          :current-page="currentPage"
          :per-page="perPage">
        <template v-slot:cell(show_details)="row">
          <b-button size="sm" @click="row.toggleDetails" class="mr-2">
            {{ row.detailsShowing ? 'Закрити' : 'Відкрити' }} Деталі
          </b-button>
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Ім'я</b></b-col>
              <b-col>{{ row.item['Ім\'я'] }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Компанія</b></b-col>
              <b-col>{{ row.item['Компанія'] }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Телефон</b></b-col>
              <b-col>{{ row.item['Телефон'] }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>ЕДРПОУ</b></b-col>
              <b-col>{{ row.item['ЕДРПОУ'] }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Адреса</b></b-col>
              <b-col>{{ row.item['Адреса'] }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Менеджер</b></b-col>
              <b-col>{{ row.item['Менеджер'] }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Є активне замовлення</b></b-col>
              <b-col>{{ row.item['Є активне замовлення'] ? '+' : '-' }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right bonuses"><b>Бонусів</b></b-col>
              <b-col>
                <b-form-input v-model="row.item['Бонусів']" @change="() => storeBonuses(row)">
                  {{ row.item['Бонусів'] }}
                </b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right bonuses"><b>Знижка</b></b-col>
              <b-col>
                <b-form-input v-model="row.item['Знижка']" @change="() => storeBonuses(row)">
                  {{ row.item['Знижка'] }}
                </b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Кількість замовлень</b></b-col>
              <b-col>{{ row.item['Кількість замовлень'] }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Вартість замовлень</b></b-col>
              <b-col>{{ row.item['Вартість замовлень'] }}</b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="3" class="text-sm-right"><b>Об'єм</b></b-col>
              <b-col>{{ row.item['Об\'єм'] }}</b-col>
            </b-row>

            <b-button size="sm" @click="row.toggleDetails">Закрити Деталі</b-button>
          </b-card>
        </template>
      </b-table>
    </div>

  </div>
</template>

<script lang="js">
import LoadSpinner from '../components/LoadSpinner';
import {editClient, getFullClientsChunk} from "@/services/Clients.service";

export default {
  name: 'src-components-clients',
  props: [],
  components: {LoadSpinner},
  async mounted() {
    await this.getClients();
  },
  data() {
    return {
      showSpinner: false,
      reqSuccess: true,
      reqResult: '',

      // is used to reload items, to rerender
      reload: false,

      //pagination
      length: 0, // amount of clients in db
      offset: 0, // how many items should be skipped (to load next page)
      currentPage: 1,
      rows: 2, // dunno
      perPage: 15, // items on page

      // table
      fields: ['Ім\'я', 'Компанія', 'Телефон', 'Кількість замовлень', 'show_details'],
      items: []
    }
  },
  methods: {
    showModal() {
      this.$refs['req-result'].show();
      setTimeout(() => {
        this.$refs['req-result'].hide();
      }, 2000);
    },
    click(e) {
      this.currentPage = e;
      this.getClients();
    },
    getClients() {
      this.showSpinner = true;
      this.reload = true;
      const offset = (this.currentPage - 1) * this.perPage;
      getFullClientsChunk(this.perPage, offset)
          .then(({customers, length}) => {
            const keys = Object.keys(customers);
            this.items.length = length;
            this.length = length;
            for (let i = 0; i < this.items.length && keys.length; i += 1) {
              if (!this.items[i]) {
                const customer = customers[keys[0]];
                this.items[i] = {
                  id: keys.shift(),
                  'Ім\'я': customer.name,
                  'Компанія': customer.company,
                  'Телефон': customer.phone,
                  'ЕДРПОУ': customer.edrpou,
                  'Адреса': customer.address,
                  'Менеджер': customer.manager,
                  'Є активне замовлення': customer.activeOrder,
                  'Бонусів': +customer.bonuses,
                  'Кількість замовлень': customer.ordersAmount,
                  'Вартість замовлень': customer.ordersVolume,
                  'Знижка': customer.discount,
                  'Об\'єм': customer.volume,
                };
              }
            }
            this.reqSuccess = true;
            this.reload = false;
            this.showSpinner = false;
          })
          .catch(err => {
            this.showSpinner = false;
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showModal();
          });
    },
    storeBonuses(row) {
      let id = row.item.id;
      let bonuses = row.item['Бонусів'];
      let discount = row.item['Знижка'];

      bonuses = parseFloat(bonuses.toString().replace(',', '.'));
      discount = parseFloat(discount.toString().replace(',', '.'));

      if (isNaN(bonuses)) {
        return
      }
      if (isNaN(discount)) {
        return
      }

      this.showSpinner = true;
      editClient(id, +bonuses, +discount)
          .then(() => {
            this.showSpinner = false;
            this.reqResult = 'Дані змінені';
            this.reqSuccess = true;
            this.showModal();
          })
          .catch(err => {
            this.reqResult = 'Трапилася помилка на сервері, зверніться до адміністратора';
            this.reqSuccess = false;
            this.showSpinner = false;
            this.showModal();
          });
    }
  },
  computed: {},
  watch: {}
}
</script>

<style lang="scss">
.wrapper {
  padding: 16px 32px;

  .clients {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .text-sm-right.bonuses.col-sm-3 {
    align-items: center !important;
    display: flex;
    justify-content: flex-end !important;
  }

  .text-sm-right.bonuses.col-sm-3 b {
    text-align: end;
  }
}

.message-fail {
  color: red !important;
}

.message-success {
  color: green;
}
</style>
